export const getToscaneData = () => ({
  name: "Toscane",
  country: "Italie",
  description: "La Toscane est le cœur viticole de l'Italie, réputée pour ses vins rouges élégants et ses paysages de vignobles pittoresques.",
  type: "region",
  mapAreas: [
    { region: "Toscane", x: 50, y: 45, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "63,000 ha",
    production: "2,200,000 hl",
    wineries: "1,200+ domaines",
    villages: "25+ communes",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré, étés chauds et secs",
    soil: "Sols argilo-calcaires, galestro, albarese",
    viticulture: "Vendanges manuelles, cépages autochtones, DOCG strictes"
  },
  wineStyles: {
    red: "Rouges élégants et structurés (Chianti, Brunello, Vino Nobile)",
    white: "Blancs secs et minéraux (Vernaccia di San Gimignano)",
    dessert: "Vin Santo, dessert wines traditionnels"
  },
  history: "La Toscane produit du vin depuis l'époque étrusque. Le Chianti est devenu le vin italien le plus célèbre au monde.",
  foodPairing: "Bistecca alla fiorentina, pâtes toscanes, fromages pecorino, charcuteries",
  subregions: {
    "chianti-classico": {
      name: "Chianti Classico",
      area: "7,200 ha",
      percentage: "11.4%",
      description: "Cœur historique du Chianti",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Galestro et albarese",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Sangiovese", "Canaiolo", "Colorino"]
      },
      wineStyles: {
        red: "Rouges élégants et structurés"
      },
      foodPairing: "Bistecca alla fiorentina, pâtes toscanes"
    },
    "brunello-di-montalcino": {
      name: "Brunello di Montalcino",
      area: "2,100 ha",
      percentage: "3.3%",
      description: "Vins rouges de garde",
      characteristics: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols argilo-calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Sangiovese Grosso"]
      },
      wineStyles: {
        red: "Rouges de garde puissants"
      },
      foodPairing: "Viandes rouges, fromages affinés"
    },
    "vino-nobile-di-montepulciano": {
      name: "Vino Nobile di Montepulciano",
      area: "1,650 ha",
      percentage: "2.6%",
      description: "Vins nobles traditionnels",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols argilo-calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Sangiovese", "Canaiolo", "Mammolo"]
      },
      wineStyles: {
        red: "Rouges nobles et élégants"
      },
      foodPairing: "Viandes rouges, fromages pecorino"
    },
    "bolgheri": {
      name: "Bolgheri",
      area: "1,200 ha",
      percentage: "1.9%",
      description: "Super Tuscans modernes",
      characteristics: {
        climate: "Climat maritime méditerranéen",
        soil: "Sols sableux et argileux",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Super Tuscans internationaux"
      },
      foodPairing: "Viandes rouges, plats sophistiqués"
    },
    "maremma": {
      name: "Maremma",
      area: "8,000 ha",
      percentage: "12.7%",
      description: "Région côtière émergente",
      characteristics: {
        climate: "Climat maritime méditerranéen",
        soil: "Sols variés, influence maritime",
        viticulture: "Vendanges mécaniques et manuelles"
      },
      grapeVarieties: {
        red: ["Sangiovese", "Cabernet Sauvignon", "Merlot"],
        white: ["Vermentino", "Trebbiano"]
      },
      wineStyles: {
        red: "Rouges modernes et fruités",
        white: "Blancs frais et minéraux"
      },
      foodPairing: "Poissons, fruits de mer, viandes blanches"
    }
  },
  grapeVarieties: [
    { name: "Sangiovese", percentage: "70%", description: "Cépage principal de la Toscane" },
    { name: "Canaiolo", percentage: "10%", description: "Cépage traditionnel d'assemblage" },
    { name: "Colorino", percentage: "5%", description: "Cépage colorant" },
    { name: "Cabernet Sauvignon", percentage: "8%", description: "Cépage international" },
    { name: "Merlot", percentage: "5%", description: "Cépage international" },
    { name: "Autres", percentage: "2%", description: "Cépages mineurs" }
  ]
}); 